import { Badge, NumberFormatter } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Player } from 'shared/api';
import BalanceIcon from 'shared/ui/assets/balance-icon.svg?react';
import { gamePageModel } from '../../model';
import { GamePageActiveIndicator } from '../game-page-active-indicator';
import cls from './game-page-player.module.scss';

export type GamePagePlayerProps = {
	player: Player;
	actionSlot: (player: Player) => ReactNode;
};

export const GamePagePlayer = ({ player, actionSlot }: GamePagePlayerProps) => {
	const { t } = useTranslation();

	const currency = useUnit(gamePageModel.$currency);

	return (
		<div className={cls.gamePagePlayer}>
			<div className={cls.gamePagePlayerLeftWrapper}>
				<div className={cls.gamePagePlayerGroup}>
					<Badge
						size='xl'
						radius='sm'
						data-number={player.order}
						className={cls.gamePageAccordionBadge}
					>
						{player.order}
					</Badge>
					<div className={cls.gamePagePlayerLabel}>
						<span className={cls.gamePagePlayerLabelName}>{player.name}</span>
						<GamePageActiveIndicator active={player.isConnected} />
					</div>
				</div>
			</div>
			<div className={cls.gamePagePlayerBalance}>
				<div className={cls.gamePagePlayerBalanceBalance}>
					<BalanceIcon className={cls.gamePagePlayerBalanceIcon} />
					<span className={cls.gamePagePlayerBalanceLabel}>{t('game-page.balance')}: &nbsp;</span>
					{player.voucherItem !== null ? (
						<>
							<NumberFormatter value={player.voucherItem.currentDeposit} />
							<span>&nbsp;/&nbsp;</span>
							<NumberFormatter
								value={player.voucherItem.totalDeposit}
								suffix={` ${currency}`}
							/>
						</>
					) : (
						<NumberFormatter
							value={player.balance}
							suffix={` ${currency}`}
						/>
					)}
				</div>
				{player.voucherItem !== null && (
					<div className={cls.gamePagePlayerBalanceBalance}>
						<BalanceIcon className={cls.gamePagePlayerBalanceIcon} />
						<span className={cls.gamePagePlayerBalanceLabel}>
							{t('game-page.wagering')}: &nbsp;
						</span>
						<NumberFormatter value={player.voucherItem.currentWagering} />
						<span>&nbsp;/&nbsp;</span>
						<NumberFormatter
							value={player.voucherItem.totalWagering}
							suffix={` ${currency}`}
						/>
					</div>
				)}
				<div className={cls.gamePagePlayerBalanceButtons}>{actionSlot(player)}</div>
			</div>
		</div>
	);
};
